import { ReactElement, useCallback } from 'react';

import { useBoolean } from '@dreryk/react-common';

import { EwusLoginModal } from './EwusLoginModal';

type EwusLoginModalRenderProps = {
   onLogin: () => Promise<unknown> | void;
};

type UseEuwsLoginModalReturnFn = {
   renderEwusLoginModal: (renderProps?: EwusLoginModalRenderProps) => ReactElement | null;
   openEwusLoginModal: VoidFunction;
};

export const useEwusLoginModal = (): UseEuwsLoginModalReturnFn => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   return {
      openEwusLoginModal: openModal,
      renderEwusLoginModal: useCallback(
         (renderProps) => {
            if (modalOpened) {
               return <EwusLoginModal onLogin={renderProps?.onLogin} onClose={closeModal} />;
            }

            return null;
         },
         [closeModal, modalOpened]
      ),
   };
};
